export enum SocureStatus {
  SdkInitializeError = "EXCEPTION",
  AppOpened = "APP_OPENED",
  WaitingForRedirectMethod = "WAITING_FOR_REDIRECT_METHOD",
  WaitingForUserToRedirect = "WAITING_FOR_USER_TO_REDIRECT",
  WaitingForUpload = "WAITING_FOR_UPLOAD",
  DocumentUploaded = "DOCUMENTS_UPLOADED",
  DocumentFrontUploaded = "DOCUMENT_FRONT_UPLOADED",
  DocumentSelieUploaded = "DOCUMENT_SELFIE_UPLOADED",
  Verifying = "VERIFYING",
  VerifyingComplete = "VERIFICATION_COMPLETE",
  VerifyingError = "VERIFICATION_ERROR",
  SessionComplete = "SESSION_COMPLETE",
  SessionExpired = "SESSION_EXPIRED"
}
